import { render, staticRenderFns } from "./UiNotifications.vue?vue&type=template&id=e9c3acea&"
import script from "./UiNotifications.vue?vue&type=script&lang=js&"
export * from "./UiNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports